import { render, staticRenderFns } from "./CaseStudies.vue?vue&type=template&id=5c4c5fa9&"
import script from "./CaseStudies.vue?vue&type=script&lang=ts&"
export * from "./CaseStudies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports